export class sc24RegionNoteType {
  static type_pre_travel_declaration = 'pre_travel_declaration';
  static type_veterinary_inspection = 'veterinary_inspection';
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/note-types.ts